import Dexie, { Transaction } from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";
import { StoredDispatchedServiceSyncData } from "src/app/driver/storage/models/stored-dispatched-service-sync-data";

/**
 * Defines the upgrade path for version 9 of indexed DB.
 */
export class DatabaseUpgradeV9 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 9;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).upgrade((transaction: Transaction) => {
			// Adds LegacyOrderId and ServiceType to sync data
			return transaction.table("DispatchedServiceSyncData").toCollection().modify((storedSyncData: StoredDispatchedServiceSyncData) => {
				if (!storedSyncData.LegacyOrderId) {
					storedSyncData.LegacyOrderId = 0,
					storedSyncData.ServiceType = ""
				}
			});
		});
	}
}